module.exports = __webpack_public_path__ + "static/media/09_(c)_stephan_anders.a0d9ce3a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/0420/koeln/09_(c)_stephan_anders.jpg
// module id = 2270
// module chunks = 0